export default __webpack_public_path__ + "static/media/star-1.b8be8e1f.png";